export const quizQuestions = [
    {
      question: 'Is it OK to refuse a fare if the fare is only a short one?',
      options: [
        { label: 'No', value: 'No', correct: true },
        { label: 'Yes', value: 'Yes', correct: false },
      ],
    },
    {
      question: 'Which of the following is an example of good customer service?',
      options: [
        { label: 'Rolling your eyes', value: 'Rolling your eyes', correct: false },
        { label: 'Looking angry', value: 'Looking angry', correct: false },
        { label: 'Shaking your fist at another driver', value: 'Shaking your fist at another driver', correct: false },
        { label: 'Smiling in a friendly way', value: 'Smiling in a friendly way', correct: true },
      ],
    },
    {
      question: 'What is the blood alcohol limit for taxi drivers?',
      options: [
        { label: 'Under 0.05', value: 'Under 0.05', correct: false },
        { label: 'Zero', value: 'Zero', correct: true },
        { label: '0.02', value: '0.02', correct: false },
        { label: 'Unlimited', value: 'Unlimited', correct: false },
      ],
    },
    {
      question: 'As a taxi driver who do you have a duty of care to?',
      options: [
        { label: 'Yourself, passengers, others', value: 'Yourself, passengers, others', correct: true },
        { label: 'Yourself, your family, Australia', value: 'Yourself, your family, Australia', correct: false },
        { label: 'No-one but yourself', value: 'No-one but yourself', correct: false },
        { label: 'Your employer', value: 'Your employer', correct: false },
      ],
    },
    {
      question: 'If you notice a safety hazard in your vehicle what should you do?',
      options: [
        { label: 'Contact the affiliate provider (operator) immediately for instructions', value: 'Contact the affiliate provider (operator) immediately for instructions', correct: false },
        { label: 'Record it on your driver worksheet', value: 'Record it on your driver worksheet', correct: false },
        { label: 'All of the above', value: 'All of the above', correct: true },
        { label: 'Don’t pick up any more passengers', value: 'Don’t pick up any more passengers', correct: false },
      ],
    },
    {
      question: 'Which of the options is an appropriate question to ask a passenger?',
      options: [
        { label: 'What’s wrong with you anyway?', value: 'What’s wrong with you anyway?', correct: false },
        { label: 'How old are you?', value: 'How old are you?', correct: false },
        { label: 'What war did you serve in?', value: 'What war did you serve in?', correct: false },
        { label: 'Can I assist you at all?', value: 'Can I assist you at all?', correct: true },
      ],
    },
    {
      question: 'What is a good way to prevent stress and anger?',
      options: [
        { label: 'Get enough sleep', value: 'Get enough sleep', correct: false },
        { label: 'Get some regular exercise', value: 'Get some regular exercise', correct: false },
        { label: 'All of the above', value: 'All of the above', correct: true },
        { label: 'Don’t take things personally', value: 'Don’t take things personally', correct: false },
      ],
    },
    {
      question: 'Which documents regulate what taxi drivers can and can’t do?',
      options: [
        { label: 'Network Policies and Procedures', value: 'Network Policies and Procedures', correct: false },
        { label: 'Point to Point Transport Regulations', value: 'Point to Point Transport Regulations', correct: false },
        { label: 'All of the above', value: 'All of the above', correct: true },
        { label: 'The NSW Road Rules', value: 'The NSW Road Rules', correct: false },
      ],
    },
    {
      question: 'Irritability and sore eyes might tell you it’s time to...',
      options: [
        { label: 'Be aware, but keep driving until you start to become drowsy', value: 'Be aware, but keep driving until you start to become drowsy', correct: false },
        { label: 'Do nothing, you’ll feel better in 30 minutes', value: 'Do nothing, you’ll feel better in 30 minutes', correct: false },
        { label: 'Take a break, you are becoming fatigued', value: 'Take a break, you are becoming fatigued', correct: true },
      ],
    },
    {
      question: 'Is this statement true or false? Opera Taxis can search a driver by asking them to empty their pockets, open bags or jackets to look for drugs and alcohol.',
      options: [
        { label: 'False', value: 'False', correct: false },
        { label: 'True', value: 'True', correct: true },
      ],
    },
  ];